export enum PaymentMethod {
  OneClick = "OneClick",
  GPay = "GPay",
  ApplePay = "ApplePay",
}

export const paymentCBType = {
  success: "success",
  decline: "decline",
  redirect: "redirect",
};

export const paymentDeclineReason = {
  PERMANENT_CARD_BLOCK: 1,
  INTERNAL_CARD_BLOCK: 2,
  GENERAL: 3,
  INSUFFICIENT_FUNDS: 4,
  CUSTOMER_ABORT: 5,
  AUTH_3D_FAIL: 6,
  INVALID_CARD_DATA: 7,
  ANTIFRAUD_BLOCK: 8,
  VERIFICATION_REQUIRED: 9,
  SECURITY_VIOLATION: 10,
  DECLINE_FOR_CVV2_FAILURE: 11,
  TOKEN_IS_INCORRECT: 12,
  PICK_UP_CARD_NO_FRAUD: 13,
  PICK_UP_CARD_SPECIAL_CONDITIONS: 14,
  NO_SUCH_ISSUER: 15,
  PICK_UP_GENERAL: 16,
  SOLEN_CARD_PICK_UP: 17,
  CLOSED_ACCOUNT: 18,
  ISSUERS_RISK_DECLINE: 19,
};

// General bank decline
export const generalDeclineGroup = [
  paymentDeclineReason.PERMANENT_CARD_BLOCK,
  paymentDeclineReason.INTERNAL_CARD_BLOCK,
  paymentDeclineReason.GENERAL,
  paymentDeclineReason.CUSTOMER_ABORT,
  paymentDeclineReason.AUTH_3D_FAIL,
  paymentDeclineReason.INVALID_CARD_DATA,
  paymentDeclineReason.DECLINE_FOR_CVV2_FAILURE,
  paymentDeclineReason.TOKEN_IS_INCORRECT,
  paymentDeclineReason.PICK_UP_CARD_NO_FRAUD,
  paymentDeclineReason.PICK_UP_CARD_SPECIAL_CONDITIONS,
  paymentDeclineReason.NO_SUCH_ISSUER,
  paymentDeclineReason.PICK_UP_GENERAL,
  paymentDeclineReason.SOLEN_CARD_PICK_UP,
  paymentDeclineReason.CLOSED_ACCOUNT,
];

// Issuer’s risk decline
export const issuersRiskDeclineGroup = [
  paymentDeclineReason.ANTIFRAUD_BLOCK,
  paymentDeclineReason.VERIFICATION_REQUIRED,
  paymentDeclineReason.SECURITY_VIOLATION,
  paymentDeclineReason.ISSUERS_RISK_DECLINE,
];

// Insufficient funds
export const insufficientFundsGroup = [paymentDeclineReason.INSUFFICIENT_FUNDS];

// Error groups
export const GENERAL_DECLINE_GROUP = "general";
export const ISSUERS_RISK_GROUP = "issuer_risk";
export const INSUFFICIENT_FUNDS_GROUP = "insufficient_funds";

export const DISCOUNT_PERCENT = 1;
export const DISCOUNT_MONEY = 2;

export const INITIAL_OFFER_DISCOUNT = 1;
export const REGULAR_PRICE_DISCOUNT = 2;
export const ONE_TIME_OFFER_DISCOUNT = 3;
export const HAPPY_BIRTHDAY_DISCOUNT = 4;

export const RISK_JS_INTEGRITY_DEV =
  "sha384-fOaCPIhHNNFNHXHKks9iDyZiQKz4PCq/SIA9+IM4+ApcYI0bxLL+BVyabmiOLtJj";
export const RISK_JS_INTEGRITY_PROD =
  "sha384-JS/Q0U1PlEbjK05xn23jCiI9IGUnrXO4HmTcz+sEA6z+n4qfKYfPIzm1Knev67+G";

export const APPLE_PAY_SDK_URL =
  "https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js";

export const sitesWithRiskJs = [
  "amourlee",
  "quickmedates",
  "amourforme",
  "asianforme",
  "latinmelodies",
  "cupidlee",
  "cupidticket",
  "interchatify",
  "minglechats",
];
